const KeyboardKeys = {
    Enter: 13,
    Shift: 16,
};
export default KeyboardKeys;
